import React from "react";
import { Conversation } from "../../../models/Conversation";
import { Link } from "../../../design/link";
import moment from "moment";
import { Avatar } from "../../../design/avatar";
import { Subheading } from "../../../design/heading";
import { useUser } from "../../../contexts/UserContext";
import UserGroupAvatar from "../../../components/UserGroupAvatar";

interface ConversationListItemProps {
  conversation: Conversation;
}

const ConversationListItem: React.FC<ConversationListItemProps> = ({
  conversation,
}) => {
  const { currentUser } = useUser();
  const isUnread = false; // Replace with actual unread logic
  const conversationUsers = (conversation.users || []).filter(
    (user) => user._id !== currentUser?._id,
  );
  const sender =
    conversationUsers
      .map((user) => (typeof user === "string" ? user : user.name))
      .join(", ") || "Unknown Sender";
  const subject = conversation.subject || "(No Subject)";
  const preview = conversation.lastMessage?.content || "No message content";
  const updatedAt = moment(conversation.updatedAt).fromNow();

  return (
    <Link href={`/conversation/${conversation._id}`}>
      <div className="flex items-start gap-4 p-4 transition border-b border-gray-200 hover:bg-gray-100">
        {/* Avatar */}
        <UserGroupAvatar
          users={conversationUsers.map((user) => ({
            avatarUrl: user.avatarUrl,
            initials: user.initials,
          }))}
          size={40}
        />

        {/* Content */}
        <div className="flex flex-col flex-1">
          <div className="flex items-center justify-between">
            <Subheading>{sender}</Subheading>
            <span className="text-xs text-gray-500">{updatedAt}</span>
          </div>
          <div
            className={`text-base ${isUnread ? "font-bold text-black" : "text-gray-900"} mt-1`}
          >
            {subject}
          </div>
          <div className="mt-1 text-sm text-gray-600 line-clamp-4">
            {preview}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ConversationListItem;
